import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteAirlines } from "../../api/apiAirlines";
import parseError from "../../utils/parseError";

const useForceDeleteAllAirlines = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAllAirlinesAction, isPending } = useMutation({
        mutationFn: massForceDeleteAirlines,
        onSuccess: (res) => {
            const message = res?.message || "Airlines permanently deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airlines"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete airlines");
        },
    });

    return { forceDeleteAllAirlines: forceDeleteAllAirlinesAction, isPending };
};

export default useForceDeleteAllAirlines;
